import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import { StoreListFilters } from "@modules/stores/components/StoreListFilters";

import { useStoresList } from "./controller";
import { useStoresListColumns } from "./columns";

export const StoreList = React.memo(() => {
  const {
    rows,
    loading,
    selectedRows,
    dataToExport,
    companies,
    setSelectedRows,
    refetch,
    translate,
    tableProps
  } = useStoresList();

  const columns = useStoresListColumns(refetch, translate, companies);

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
              for_agreement: "",
            }}
          >
            <StoreListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="agreements.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />
    </List>
  );
});
